import React from 'react';
import logo from '../img/vana png.png'; // Make sure the logo image is placed in the 'img' folder
import '../style/Footer.css'
const Footer = () => {
  return (
    <div>
      <footer className="py-4 ">
       
          <div className="row py-4 d-flex align-items-top border border-bottom-0">
            <div className="col-12 col-lg-3 mb-4 mb-lg-0 d-flex flex-column align-items-center">
              <img
                alt="Vana Tour and Car Rental Logo"
                className="img-fluid mb-3"
                height=""
                src={logo}
                width="200 "
              />
              <p className="mb-1">Vana Tour and Car Rental</p>
              <p className=" mb-1">Addis Ababa, Ethiopia</p>
              <p className=" mb-1">Tel: +251 911-123-456</p>
              <p className=" mb-0">
                <a className="text-dark text-decoration-none" href="mailto:info@vanatours.com">
                  info@vanatours.com
                </a>
              </p>
            </div>
            <div className="col-6 col-lg-2 mb-4 mb-lg-0">
              <h4>Quick Links</h4>
              <ul className="list-unstyled">
                <li className="mb-1">
                  <a className="text-dark text-decoration-none" href="">Home</a>
                </li>
                <li className="mb-1">
                  <a className="text-dark text-decoration-none" href="">About</a>
                </li>
               
                <li className="mb-1">
                  <a className="text-dark text-decoration-none" href="">Tours</a>
                </li>
                <li className="mb-1">
                  <a className="text-dark text-decoration-none" href="">Car Rentals</a>
                </li>
                <li className="mb-1">
                  <a className="text-dark text-decoration-none" href="">Contact</a>
                </li>
              </ul>
            </div>
            <div className="col-6 col-lg-2 mb-4 mb-lg-0">
              <h4>Useful Info</h4>
              <ul className="list-unstyled">
                <li className="mb-1">
                  <a className="text-dark text-decoration-none" href="">How it Works</a>
                </li>
                <li className="mb-1">
                  <a className="text-dark text-decoration-none" href="">FAQ</a>
                </li>
                <li className="mb-0">
                  <a className="text-dark text-decoration-none" href="">Contact Us</a>
                </li>
              </ul>
            </div>
            <div className="col-6 col-lg-2 mb-4 mb-lg-0">
              <h4>My Account</h4>
              <ul className="list-unstyled">
                <li className="mb-1">
                  <a className="text-dark text-decoration-none" href="">Get Help</a>
                </li>
                <li className="mb-1">
                  <a className="text-dark text-decoration-none" href="">My Books</a>
                </li>
              
              </ul>
            </div>
            <div className="col-12 col-lg-3">
              <div className="border-top pt-4 d-lg-none"></div>
              <h4>Subscribe</h4>
              <div className="input-group mb-2">
                <input
                  className="form-control bg-light"
                  placeholder="Email address"
                  type="text"
                />
                <button className="btn" style={{ backgroundColor: '#007bff', color: 'white' }} type="button">
                  Subscribe
                </button>
              </div>
              <p className=" text-muted mb-0">
                Sign up for our newsletter to get the latest updates on features and releases.
              </p>
            </div>
          </div>
          <div className="d-lg-flex align-items-center justify-content-between border-top py-3 py-lg-2 mt-lg-5">
            <div className="small mb-2 mb-lg-0 text-muted">
              © 2024 Vana Tour and Car Rental. All rights reserved.
            </div>
            <div className="">
              <a className="d-block d-lg-inline text-muted ms-lg-3 mb-2 mb-lg-0" href="">
                Privacy Policy
              </a>
              <a className="d-block d-lg-inline text-muted ms-lg-3 mb-2 mb-lg-0" href="">
                Terms of Service
              </a>
            </div>
            <div className="d-none d-lg-block ms-auto">
              <a className="me-2" href="">
                <svg className="bi bi-pinterest text-primary" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0z"></path>
                </svg>
              </a>
              <a className="me-2" href="">
                <svg className="bi bi-twitter text-primary" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.346 9.346 0 0 0 5.026 15z"></path>
                </svg>
              </a>
              <a className="me-2" href="">
                <svg className="bi bi-facebook text-primary" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8zM7.451 4.159h1.307v1.326H7.451V4.159zM7.451 5.485h1.307v1.326H7.451V5.485zM7.451 6.811h1.307v1.326H7.451V6.811zM8 9.73c-1.748 0-3.176 1.477-3.176 3.29v.103h6.352v-.103c0-1.813-1.428-3.29-3.176-3.29z"></path>
                </svg>
              </a>
            </div>
          </div>
       
      </footer>
    </div>
  );
}

export default Footer;

